import { Property } from '@propertypal/shared/src/types/property';
import getSellingAgent from '@propertypal/shared/src/utils/property/getSellingAgent';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../typography';
import { AgentLogo, Container, PremierContainer } from './PropertyBoxFooter.style';

interface Props {
  property: Property;
  premium: boolean;
  logos?: string[] | null;
}

const PropertyBoxFooter: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const sellingAgent = getSellingAgent(props.property);
  const hasWhiteBg = props.property.account.logo?.premierBackgroundColour === '#ffffff';

  const agentLogos = () => {
    if (props?.logos && props.logos?.length > 0)
      return props.logos.map((logo) => (
        <AgentLogo src={logo} key={logo} alt={`${sellingAgent} Logo`} aria-hidden="true" />
      ));
    return null;
  };

  if (props.premium) {
    return (
      <PremierContainer color={props.property.account.logo?.premierBackgroundColour}>
        {!!sellingAgent && (
          <Text fontSize={12} color={hasWhiteBg ? theme.darkGrey : theme.white}>
            Marketed by {sellingAgent}
          </Text>
        )}

        {agentLogos()}
      </PremierContainer>
    );
  }

  return (
    <Container>
      {agentLogos()}

      {!!sellingAgent && (
        <div>
          <Text fontSize={12}>Marketed by</Text>
          <Text fontSize={12}>{sellingAgent}</Text>
        </div>
      )}
    </Container>
  );
};

export default PropertyBoxFooter;
